import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Presentacion.css'; // Asegúrate de importar el archivo CSS

export default function Presentacion({ settings }) {
  const captionSt = {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    padding: "10px",
    borderRadius: "5px",
    color: "white"
  };

  const captionStP = {
    fontSize: "14px",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    padding: "5px",
    borderRadius: "3px",
    color: "white"
  };

  return (
    <Carousel variant="dark" className="carousel-container">
      {settings.map((slide, index) => (
        <Carousel.Item key={index}>
          <img className="d-block w-100" src={slide.imgSrc} alt={`Slide ${index + 1}`} />
          <Carousel.Caption>
            <h5 style={captionSt}>{slide.title}</h5>
            <p style={captionStP}>{slide.description}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
